import React from 'react';
import { BM_LOGO } from './logo-data';
import './bossmilan-preloader.scss';

// Emblem is embedded as base64 (logo-data.ts) so it can never 404 during load.
const FAVICON_URL = BM_LOGO;

interface BossMilanPreloaderProps {
    is_visible?: boolean;
}

const BossMilanPreloader = ({ is_visible = true }: BossMilanPreloaderProps) => (
    <div className={`bossmilan-preloader${is_visible ? '' : ' bossmilan-preloader--hidden'}`}>
        <div className='bossmilan-preloader__logo-wrap'>
            <div className='bossmilan-preloader__ring' />
            <div className='bossmilan-preloader__glow' />
            <img
                className='bossmilan-preloader__icon'
                src={FAVICON_URL}
                alt='BossMilan'
                draggable={false}
            />
        </div>

        <div className='bossmilan-preloader__wordmark'>
            <span>Boss</span>
            <span>Milan</span>
        </div>

        <div className='bossmilan-preloader__bar-track'>
            <div className='bossmilan-preloader__bar-fill' />
        </div>

        <div className='bossmilan-preloader__dots'>
            <span />
            <span />
            <span />
        </div>
    </div>
);

export default BossMilanPreloader;
